/* eslint-disable @typescript-eslint/indent */
import { Box, ButtonLink, PinField, Stack, Text2, Text3, skinVars } from "@telefonica/mistica";
import { observer } from "mobx-react-lite";
import React, { useEffect } from "react";
import { strings } from "../../../localization";
import { formatSeconds } from "../../../utils/formatters";

export interface PinInputTypes {
	timeAwait?: number;
	title?: string;
	value: string;
	tryAgainLabel?: string;
	tryAgainButtonLabel?: string;
	attempts: number;
	isError?: boolean;
	isDisabled?: boolean;
	helperText?: string;
	onChange(t: string): void;
	onResend(): void;
}

const INTERVAL_COUNTER = 1000;
const TIME_AWAIT = 5 * 60;

const PinInput: React.FC<PinInputTypes> = observer((props) => {
	const defaultLabels = strings.organisms.pinInput;
	const defaultTryAgainButtonLabel = strings.components.buttons.resendCode;
	const {
		value,
		timeAwait = 59,
		title = defaultLabels.title,
		tryAgainLabel = defaultLabels.tryAgainLabel,
		tryAgainButtonLabel = defaultTryAgainButtonLabel,
		isError: customIsError = undefined,
		isDisabled = false,
		helperText: customHelperText = undefined,
		attempts,
		onChange,
		onResend,
	} = props;

	const [seconds, setSeconds] = React.useState(timeAwait);
	const isError = customIsError !== undefined ? customIsError : attempts < 3 ? true : false;
	const errorLabel =
		customHelperText !== undefined
			? customHelperText === ""
				? undefined
				: customHelperText
			: isError
				? attempts < 3 && defaultLabels.errorField(attempts)
				: undefined;

	const resetTimer = (): void => {
		onResend();
		setSeconds(timeAwait);
	};

	useEffect(() => {
		if (attempts === 0) {
			setSeconds(TIME_AWAIT);
		}
	}, [attempts]);

	useEffect(() => {
		let interval: NodeJS.Timer;
		const decrementTimer = (): void => {
			if (seconds > 0) {
				setSeconds((prevSeconds) => prevSeconds - 1);
			}
		};
		if (seconds > 0) {
			interval = setInterval(decrementTimer, INTERVAL_COUNTER);
		}
		return () => {
			clearInterval(interval);
		};
	}, [seconds]);

	return (
		<Stack space={16} className="text-align-center">
			<Text3 regular>{title}</Text3>
			<PinField
				name="otp-token"
				value={value}
				onChangeValue={onChange}
				error={isError}
				helperText={errorLabel || undefined}
				disabled={isDisabled}
				data-cs-mask
			/>
			<Box className="text-align-center" paddingBottom={32}>
				<Stack space={16}>
					<Text2 color={skinVars.colors.textSecondary} regular>{`${tryAgainLabel} ${formatSeconds(seconds)}`}</Text2>
					<ButtonLink onPress={resetTimer} disabled={seconds > 0} dataAttributes={{ testid: "button-link" }}>
						<Text2 medium color={skinVars.colors.textLink}>
							{tryAgainButtonLabel}
						</Text2>
					</ButtonLink>
				</Stack>
			</Box>
		</Stack>
	);
});

export default PinInput;
